module.exports = __webpack_public_path__ + "media/images/details__prizeBox__stretch__first-f8eaa9ba4ebcfdf6b2363b08c13842d1.png";